import React from 'react'

import { theme } from '../../theme'
import { SIconSpan } from '../../../common/styles/Icons'

interface IAlertIconProps {
    fill?: string
    size?: number
    title?: string
    id?: string
}

export function AlertIcon({
    fill = theme.brandColors.CA_Black,
    size = 14,
    title,
    id = 'info-icon',
}: IAlertIconProps): React.ReactElement {
    return (
        <SIconSpan title={title} id={id} size={size}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 25 25"
                version="1.1"
                id="svg4"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs id="defs8" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill={fill}
                    d="m 17.282704,4.5823521 c -1.482,-0.89517 -3.1968,-1.36291 -4.9518,-1.33082 -2.3567896,0.04309 -4.6081896,0.98428 -6.2944096,2.63134 -1.68621,1.64706 -2.67997,3.87571 -2.77841,6.2308099 -0.09844,2.3551 0.70594,4.6589 2.24882,6.4409 1.54288,1.782 3.70784,2.9079 6.0527996,3.1475 2.3449,0.2396 4.6928,-0.4251 6.5643,-1.8582 1.8714,-1.4332 3.1251,-3.5267 3.505,-5.853 0.3728,-2.2826 -0.1232,-4.6204499 -1.3874,-6.5534899 l -0.1684,-0.25754 -1.1067,1.10674 0.1053,0.16865 c 0.9715,1.5546099 1.3555,3.4100399 1.0748,5.2292399 -0.2978,1.9305 -1.3217,3.6744 -2.8623,4.8753 -1.5406,1.2009 -3.4817,1.7681 -5.4266,1.5857 -1.9448296,-0.1825 -3.7465896,-1.1007 -5.0370496,-2.5671 -1.29046,-1.4665 -1.97222,-3.3704 -1.90588,-5.3226 0.06633,-1.95228 0.87575,-3.8054999 2.26277,-5.1809499 1.38702,-1.37545 3.2469596,-2.16928 5.1996596,-2.21926 1.3629,-0.03488 2.6991,0.29438 3.8768,0.93933 l 0.1644,0.09 1.1375,-1.13751 z m -3.7827,10.6676299 h -2 v 2 h 2 z m 0,-7.9999999 h -2 v 6.4999999 h 2 z"
                    id="path2"
                />
            </svg>
        </SIconSpan>
    )
}
